/**
 * What an agency-scoped page shows to an account that has no agency.
 *
 * Rendered instead of the page, not alongside it. The whole point is that the
 * page would otherwise come back empty and look like an agency with no
 * clients, no deals and no money — which is a statement about a business, made
 * by a query that had nothing to filter on.
 */

import { Link } from 'react-router-dom'
import Card, { CardBody } from './Card'

export default function NoAgencyNotice({ pathname }: { pathname: string }) {
  return (
    <Card>
      <CardBody>
        <div style={{ maxWidth: '46ch', display: 'grid', gap: '0.75rem' }}>
          <div style={{ fontWeight: 600, fontSize: '1.0625rem' }}>
            This account belongs to no agency.
          </div>
          <div style={{ color: 'var(--text-secondary)', fontSize: '0.9375rem', lineHeight: 1.55 }}>
            <code style={{ fontSize: '0.875rem' }}>{pathname}</code> shows one agency's
            records, and there is no agency on this account to show. It is empty
            because nothing was asked for — not because there is nothing there.
          </div>
          <div style={{ color: 'var(--text-secondary)', fontSize: '0.9375rem', lineHeight: 1.55 }}>
            A superadmin is cross-agency by design, so this is a normal state.
            The platform-wide pages still work.
          </div>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '0.25rem' }}>
            <Link to="/admin" style={{ color: 'var(--brand)' }}>Admin panel</Link>
            <Link to="/pending-customers" style={{ color: 'var(--brand)' }}>Pending customers</Link>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}
